require('./hireSelectAccount.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ components
const SuggestSimpleList = require('components/suggestList/suggestSimpleList').SuggestSimpleList;
// @ utilities
import { FormattedText, formatText } from 'core/i18n';
// @ constants
const arrowIcon = require('assets/icons/icon-arrow.svg');

class HireSelectAccount extends React.Component {
    render() {
        return (
            <div className="hire-select-account">
                <div className="hire-select-account__list">
                    <SuggestSimpleList
                        isUpdated={function (params) {
                            return console.log('updated', params);
                        }}
                        label={formatText('hireSelectAccount-ngosLabel')}
                        name="ngos_name"
                        optionsList={[
                            { name: 'accion contra el hambre', code: 1 },
                            { name: 'comite español de acnur', code: 2 },
                            { name: 'cris contra el cancer', code: 3 },
                            { name: 'cruz roja', code: 4 },
                            { name: 'deporte y desafio', code: 5 },
                        ]}
                        placeholder={formatText('hireSelectAccount-ngosPlaceholder')}
                        profileModel="userProfile.ngos"
                        {...this.props}
                    />
                    <div className="hire-select-account__link">
                        <a href="#" onClick={event => event.preventDefault()}>
                            <FormattedText value="hireSelectAccount-ngosLink" />
                            <img className="hire-select-account__link-icon" src={arrowIcon} alt="" />
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

HireSelectAccount.propTypes = {
    charityFoundations: PropTypes.array.isRequired,
};

module.exports = HireSelectAccount;
